import {
  subscriptionLimits,
  SubscriptionPeriodAdverb,
  SubscriptionPeriodDescription
} from '@core/models';

export const getMinimumQuantityTicketSubscription = (
  originalPrice: number,
  period: SubscriptionPeriodDescription,
  discount: number = 0
): number => {
  const singlePrice = originalPrice - (originalPrice * discount) / 100;
  const limits = subscriptionLimits[period];

  return Math.ceil(limits.min / singlePrice);
};

export const getMaximumQuantityTicketSubscription = (
  originalPrice: number,
  period: SubscriptionPeriodDescription,
  discount: number = 0
): number => {
  const singlePrice = originalPrice - (originalPrice * discount) / 100;
  const limits = subscriptionLimits[period];

  return Math.floor(limits.max / singlePrice);
};

export const convertAdverbToPeriodDescription = (
  periodAdverb: SubscriptionPeriodAdverb
): SubscriptionPeriodDescription => {
  switch (periodAdverb) {
    case SubscriptionPeriodAdverb.Week:
      return SubscriptionPeriodDescription.Week;
    case SubscriptionPeriodAdverb.Month:
      return SubscriptionPeriodDescription.Month;
    case SubscriptionPeriodAdverb.TwoWeeks:
      return SubscriptionPeriodDescription.TwoWeeks;
  }
};

export const checkSubscriptionEndDateRules48Hours = (
  endDate: string
): boolean =>
  new Date(endDate) < new Date(new Date().getTime() + 48 * 60 * 60 * 1000);
